import { React, useState, useEffect } from "react";
import { Button, Form, Input } from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DetailFields,
} from "../../../styledElements";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../../Assets/Icons/alertGreen.svg";
import {
  cancelParentReelProduction,
  getParentReelDetailsById,
  cancelMultiStageParentSet,
  cancelCuttingMultiStageParentSet,
  getCuttingParentReelDetailsById
} from "../../../../Services/productionPlanningServices";
import { weightUnit } from "../../../../Utils/Constant/MeasurementUnitList";

const { TextArea } = Input;
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const CancelProductionDrawer = ({
  jobId,
  parentReelId,
  visible,
  onCloseCancelProduction,
  onBackCancel,
  showToaster,
  setActionResponse,
  reFetch,
  jobcardType,
  tabNo
}) => {
  const [parentReelDetails, setParentReelDetails] = useState();
  const [form] = Form.useForm();

  const cancelReelProduction = (comment) => {
    if(jobcardType == "single_stage"){
      cancelParentReelProduction({
        id: jobId,
        parent_reel_id: parentReelId,
        comment: comment,
      })
        .then((response) => {
          setActionResponse({
            error: false,
            msg: "Production for parent reel is successfully cancelled",
          });
          showToaster();
          reFetch(true);
        })
        .catch((error) => {
          setActionResponse(error.response.data);
          showToaster();
        });
      showToaster();
    } else{
      if(tabNo == 6){
        cancelMultiStageParentSet({
          id: jobId,
          parent_reel_id: parentReelId,
          comment: comment
        }).then((response) => {
          setActionResponse({
            error: false,
            msg: "Production for parent reel is successfully cancelled",
          });
          showToaster();
          reFetch(true);
        }).catch((error) => {
          setActionResponse(error.response.data);
          showToaster();
        });
        showToaster();
      } else{
        cancelCuttingMultiStageParentSet({
          id: jobId,
          cutting_pattern_id: parentReelId,
          comment: comment
        }).then((response) => {
          setActionResponse({
            error: false,
            msg: "Production for parent reel is successfully cancelled",
          });
          showToaster();
          reFetch(true);
        }).catch((error) => {
          setActionResponse(error.response.data);
          showToaster();
        });
        showToaster();
      }
    }
  };

  const onFinish = (event) => {
    cancelReelProduction(event.Reason);
    onCloseCancelProduction();
  };

  useEffect(() => {
    form.resetFields();
    if(tabNo == 6 || jobcardType == "single_stage"){
      if (parentReelId)
      getParentReelDetailsById(parentReelId)
        .then((response) => {
          setParentReelDetails(response.data.data);
        })
        .catch((error) => console.log(error));
    } else{
      if (parentReelId)
      getCuttingParentReelDetailsById(parentReelId)
        .then((response) => {
          console.log(response);
          setParentReelDetails(response.data.data);
        })
        .catch((error) => console.log(error));
    }

    return () => {
      setParentReelDetails();
    };

  }, [parentReelId]);

  return parentReelDetails ? (
    <RightDrawerSidebar
      title={`Cancel Production: ${parentReelDetails.id}`}
      subtitle={`Weight: ${parseFloat(parentReelDetails.weight).toFixed(3)} ${" "} 
      ${parentReelDetails?.units?.weight ? capitalize(weightUnit[parentReelDetails.units.weight].displayName) : "T"}`}
      visible={visible}
      onClose={() => {
        onCloseCancelProduction();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                form={form}
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
              >
                <div
                  className="drawerField2"
                  style={{ paddingTop: "0px", paddingBottom: "2px" }}
                >
                  <div className="">
                    <Button
                      className="textTypeBtn textBtnIcon"
                      style={{ margin: "0px" }}
                      onClick={() => onBackCancel(parentReelId)}
                    >
                      <Iconmoon icon="left-to-thin" size={12} color="#EA655B" />{" "}
                      &nbsp;&nbsp; Go back to parent reel details
                    </Button>
                  </div>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Reason</h5>
                    <p>
                      Please specify a reason for cancelling production of this
                      parent reel
                    </p>
                  </div>
                  <Form.Item
                    name="Reason"
                    rules={[
                      {
                        required: true,
                        message: "This is a mandatory field",
                      },
                      { max: 100, message: "Max 100 characters allowed" },
                    ]}
                    className=""
                  >
                    <TextArea
                      maxLength={100}
                      style={{ height: 90 }}
                      placeholder="Reason for Cancel"
                    />
                  </Form.Item>
                </div>

                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button className="themeBtn" htmlType="submit">
                      <Iconmoon icon="wrong-file" size={16} color="#ffffff" />
                      Cancel Production for Parent Reel
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
        <AlertContainer
          color="yellow btmFix"
          icon={alertGreen}
          msg="Once production for this Parent Reel is cancelled, all the orders in this parent reel will be matched later in differet job card"
        />
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};

export default CancelProductionDrawer;
